import { FC } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "../../../../../hooks/useTranslate";
import { MODAL_Z_INDEX } from "../constants";

import { DashboardIcon } from "@/dashboard-design-system/Icon";
import { DashboardSwitch } from "@/dashboard-design-system/Switch";
import { DashboardTooltip } from "@/dashboard-design-system/Tooltip";
import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { Info } from "@/icons/outlined";

export type NotificationsSectionProps = {
  permissions: {
    notification: {
      checked: boolean;
      onChange: (checked: boolean) => void;
    };
  };
  disabled?: boolean;
};

export const NotificationsSection: FC<NotificationsSectionProps> = ({ permissions, disabled }) => {
  const { t } = useTranslate();

  return (
    <Stack direction="column" spacing={1}>
      <DashboardTypography variant="subtitle2" vibe="text-neutral-quiet">
        {t("dashboard", "userPermissionModal.notifications")?.toUpperCase()}
      </DashboardTypography>

      <Stack direction="column" spacing={1.5}>
        <Stack direction="row" gap={0.5} alignItems="center">
          <DashboardSwitch
            data-test="switch-general-permissions-notifications"
            label={t("dashboard", "userPermissionModal.notificationsPermissions.notifications")}
            checked={permissions.notification.checked}
            onChange={(event) => permissions.notification.onChange(event.target.checked)}
            disabled={disabled}
          />
          <DashboardTooltip
            title={t("dashboard", "userPermissionModal.notificationsPermissions.notifications.tooltip")}
            placement="top"
            PopperProps={{
              sx: {
                zIndex: MODAL_Z_INDEX + 1,
              },
            }}
          >
            <DashboardIcon size="small" sx={{ cursor: "pointer" }}>
              <Info />
            </DashboardIcon>
          </DashboardTooltip>
        </Stack>
      </Stack>
    </Stack>
  );
};
